export const boletimData2026Inverse = [
  {
    title: "Boletim Informativo - Junho 2026",
    link: "https://drive.google.com/file/d/1Cv9-KbbygySjA6zJdtVigvmvl7e1eCnR/preview"
  },
  {
    title: "Boletim Informativo - Maio 2026",
    link: "https://drive.google.com/file/d/1TeYicAXRvcRFy3iba1iSzq7LJcP3Wxsa/preview"
  },
  {
    title: "Boletim Informativo - Abril 2026",
    link: "https://drive.google.com/file/d/1WMwIPa_wRmvTmCYTabja_ze8F0QqPyOM/preview"
  },
  {
    title: "Boletim Informativo - Março 2026",
    link: "https://drive.google.com/file/d/1MB-vm_6LXOCFo8bX6gTLAMt2gvk94Yfu/preview"
  },
  {
    title: "Boletim Informativo - Fevereiro 2026",
    link: "https://drive.google.com/file/d/1vXczAnLGVB6cwMAK0BsXkN8ISVm2ZgTG/preview"
  },
  {
    title: "Boletim Informativo - Janeiro 2026",
    link: "https://drive.google.com/file/d/1sRMXnUCOXG0Xyv3K2qpBsguUL1eaJNK9/preview"
  }
];


export const boletimData2025Inverse = [

  {
    title: "Boletim Informativo - Dezembro 2025",
    link: "https://drive.google.com/file/d/1FGuws-5vD3FP3TfbWy2ze4ZaEQucRfO8/preview"

  },

  {
    title: "Boletim Informativo - Novembro 2025",
    link: "https://drive.google.com/file/d/1tQjXDw6DJ-J1xHZtOgvcYpQMP7XNGHFn/preview"

    
  },

  {
    title: "Boletim Informativo - Outubro 2025",
    link: "https://drive.google.com/file/d/16ixcrd0C310S-fmXzAu9iTk0S0X6wQgc/preview"

    
  },

  {
    title: "Boletim Informativo - Setembro 2025",
    link: "https://drive.google.com/file/d/1a9iJDuzj6Wz8TDuvzX6EFMEf4kHsxxpt/preview"

    
  },
  {
    title: "Boletim Informativo - Agosto 2025",
    link: "https://drive.google.com/file/d/1OPsL_x4CumQd3aXVE9I2zS0L_m92y2J6/preview"

    
  },

  {
    title: "Boletim Informativo - Julho 2025",
    link: "https://drive.google.com/file/d/1o3zCTmhrDDcQhxIYELT11_XckTw3NDH8/preview"

    
  },
  {
    title: "Boletim Informativo - Junho 2025",
    link: "https://drive.google.com/file/d/1pSO6cz_9d8WW-Pkh01R5X3XncI6olDgv/preview"

    
  },
  {
    title: "Boletim Informativo - Maio 2025",
    link: "https://drive.google.com/file/d/10fjW0T2LVLdcnQc8adQLnkNk-Bi9yQHx/preview"

    
  },
  {
    title: "Boletim Informativo - Abril 2025",
    link: "https://drive.google.com/file/d/1EJq5osYp77SSFUCN5AJa6Pf-sESafZrr/preview"

    
  },
  {
    title: "Boletim Informativo - Março 2025",
    link: "https://drive.google.com/file/d/1YH4MZtLTIye42nKpMK2gWKuO2ZQH5j_O/preview"

    
  },
  {
    title: "Boletim Informativo - Fevereiro 2025",
    link: "https://drive.google.com/file/d/1B4_zbJBkD3N_4Lb3zcTXEJFn2r3xK6er/preview"

    
  },
  {
    title: "Boletim Informativo - Janeiro 2025",
    link: "https://drive.google.com/file/d/1bCC9LtWNY_89brWsZTDA9ruKGEsRYHCY/preview"

    
  }
];



export const boletimData2024Inverse = [
  
  {
    title: "Boletim Informativo - Outubro 2024",
    link: "https://drive.google.com/file/d/1IKAuPG7hZClrSRFrz7VPxzfi-AkgaG4B/preview"  

  }, 

  {
    title: "Boletim Informativo - Setembro 2024",
    link: "https://drive.google.com/file/d/1Lj0QZrBtpcQB2JGHII8DmsKhX04jdhxv/preview"


  }, 

  {
    title: "Boletim Informativo - Agosto 2024",
    link: "https://drive.google.com/file/d/1BnMMtPwC8MzxNJa_cfboyrUNVAFU5lj3/preview"


  }, 

  {
    title: "Boletim Informativo - Julho 2024",
    link: "https://drive.google.com/file/d/1WHM6Z_iUXOOgwEmuYmz4bFi3ER0itAe3/preview"


  }, 
  

  {
    title: "Boletim Informativo - Junho 2024",
    link: "https://drive.google.com/file/d/1WSYW73FVum9r8A0z3Ob2KebqEmZ-7CFD/preview"


  },

  {
    title: "Boletim Informativo - Maio 2024",
    link: "https://drive.google.com/file/d/1aGbIqZ07Q2D78ljaZLMxcUvSah20e8s-/preview"


  },

  {
    title: "Boletim Informativo - Abril 2024",
    link: "https://drive.google.com/file/d/1c5S6eauvD0XF4dBpmn7rSfm8MhTWNV7P/preview"


  },

  {
    title: "Boletim Informativo - Março 2024",
    link: "https://drive.google.com/file/d/1tRV4CwilvuxX6_0pFC_9L40c3kUwbBkY/preview"


  },


  {
    title: "Boletim Informativo - Fevereiro 2024",
    link: "https://drive.google.com/file/d/1JN8Ojdvp7joTivo0VcssgEJBLFL4gg1q/preview"


  },

  {
    title: "Boletim Informativo - Janeiro 2024",
    link: "https://drive.google.com/file/d/1lPgYZJYZW2mshiDILGjU3Z6SN5I71Lbq/preview"


  }



  

];

export const boletimData2023Inverse = [
  
  {
    title: "Boletim Informativo - Outubro 2023",
    link: "https://drive.google.com/file/d/1xpq54gpVFNSpv8FruvV3OCB3o4fUGssD/preview"
  },
  {
    title: "Boletim Informativo - Setembro 2023",
    link: "https://drive.google.com/file/d/1BYQj1ciGuaybgd5kV47Lwet2pWtc8b7d/preview"
  },
  {
    title: "Boletim Informativo - Agosto 2023",
    link: "https://drive.google.com/file/d/1l75MdKP2ILLQdAR-BrlaDx-UYVPMaC23/preview"
  },
  {
    title: "Boletim Informativo - Julho 2023",
    link: "https://drive.google.com/file/d/1ZJfL1-B_JobJlLaWW6GjVuMpoC3wqz8T/preview"
  },
  {
    title: "Boletim Informativo - Junho 2023",
    link: "https://drive.google.com/file/d/1AkHYHaRuTmzTmuyUxOgns0orSFtom2rf/preview"
  },
  {
    title: "Boletim Informativo - Maio 2023",
    link: "https://drive.google.com/file/d/1wHLGcRmdwO1Cc8Q2zwipdF2QGJ2UwdRf/preview"
  },
  {
    title: "Boletim Informativo - Abril 2023",
    link: "https://drive.google.com/file/d/1n3zReZetu1pcthimSL85tYsBk2JULvHy/preview"
  },
  {
    title: "Boletim Informativo - Fevereiro e Março 2023",
    link: "https://drive.google.com/file/d/1jYewp_4mPgtduzGIPU-v032A3fV2HrV2/preview"
  }
];



// export const boletimData2023 = [

//   {
//     title: "Boletim Informativo - Fevereiro e Março 2023",
//     link: "https://drive.google.com/file/d/1UGlbTGNZQ6EkEpE4iIlsgam-ehoIj_i4/preview"


//   },

//   {
//     title: "Boletim Informativo - Abril 2023",
//     link: "https://drive.google.com/file/d/1OWCoNl1cIg42GF7BBDaMse8eIz4GTX6m/preview"


//   },

//   {
//     title: "Boletim Informativo - Maio 2023",
//     link: "https://drive.google.com/file/d/1bey9zysEutFq_5_mn00pPeHDTQWVMQsi/preview"


//   },

//   {
//     title: "Boletim Informativo - Junho 2023",
//     link: "https://drive.google.com/file/d/1R6Qq-Y-NFvH7asrAO3YPqdDZfmVv1A4i/preview"


//   },

//   {
//     title: "Boletim Informativo - Julho 2023",
//     link: "https://drive.google.com/file/d/1TlDTWkul1Yf9m_ejUYMc67FRyL5xuFP4/preview"


//   },

//   {
//     title: "Boletim Informativo - Agosto 2023",
//     link: "https://drive.google.com/file/d/1UcAK-5Qjjbc3hn60OSX7OfhzefWe7i9E/preview"


//   },

//   {
//     title: "Boletim Informativo - Setembro 2023",
//     link: "https://drive.google.com/file/d/1VKZxj5B31D4974xuOWKG4ai8SN_gtIzS/preview"


//   },

//   {
//     title: "Boletim Informativo - Outubro 2023",
//     link: "https://drive.google.com/file/d/1faSh61PoeZ3yCLcppsI1W_EfxeuB_KWN/preview"


//   },

//   {
//     title: "Boletim Informativo - Novembro 2023",
//     link: "https://drive.google.com/file/d/1xV-aGC6jzcXya5UBWt-1dwX0SXYwGibx/preview"


//   },

//   {
//     title: "Boletim Informativo - Dezembro 2023",
//     link: "https://drive.google.com/file/d/1zKe9kkkj7ISfz9YfTurs4vMVRWjRCQ38/preview"


//   }


// ];